module.exports = __webpack_public_path__ + "img/sofa-outline-icon.ffc16061.svg";